import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { getCategoryList } from '../actions/actions';

class SideMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      category: props.category,
      categories: [],
    };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount = () => {
    this.fetch();
  };

  fetch = () => {
    this.setState({
      loading: true,
    });
    this.props.getCategoryList().then(() => {
      const { list } = this.props;
      if (list !== null && typeof list === 'object') {
        this.setState({
          categories: list,
          loading: false,
        });
      } else {
        this.setState({
          loading: false,
        });
      }
    });
  };
  handleClick(id) {
    this.props.getSelectedCategory(id);
  }
  sortCategories = (a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0);

  render() {
    const { category, categories } = this.state;
    const url = `/${category}`;
    return (
      <div className='col-md-3'>
        <div className='side-category'>
          <h3>Categories</h3>
          <ul className='list-unstyled'>
            <li>
              <NavLink
                key={'All'}
                onClick={() => this.handleClick('All')}
                to={url}
              >
                All
              </NavLink>
            </li>
            {categories &&
              categories.sort(this.sortCategories).map((key, value) => {
                return (
                  <li key={value}>
                    <NavLink
                      key={key.id}
                      onClick={() => this.handleClick(key.id)}
                      to={url}
                    >
                      {key.name}
                    </NavLink>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { homeData } = state;
  if (homeData !== null)
    return {
      list: homeData,
    };
  return {
    list: null,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getCategoryList: () => dispatch(getCategoryList()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SideMenu);
